function plugin (Vue, options = {}) {
  Object.defineProperties(Vue.prototype, {
    $breadcrumbs: {
      get: function () {
        var crumbs = []
        for (var i = 0; i < this.$route.matched.length; i++) {
          if (this.$route.matched[i].meta && this.$route.matched[i].meta.breadcrumb) {
            crumbs.push(this.$route.matched[i])
          }
        }
        return crumbs
      }
    }
  })

  Vue.component('breadcrumbs', {
    template: '<nav class="breadcrumbs" v-if="$breadcrumbs.length"> <ul> <li v-for="(i, crumb) in $breadcrumbs"> <a v-link="crumb">{{ crumb.meta.breadcrumb }}</a> </li> </ul> </nav>'
  })
}

export default plugin



// WEBPACK FOOTER //
// ./src/components/services/breadcrumbs.js